const EARTH_EQUATORIAL_CIRCUMFERENCE_METTERS = 40075016.686; //Equatorial circumference of the Earth
const C = EARTH_EQUATORIAL_CIRCUMFERENCE_METTERS;

export const saveDefaultPosition = (lng, lat, zoom) => {
  localStorage.setItem("lng", lng);
  localStorage.setItem("lat", lat);
  localStorage.setItem("zoom", zoom);
};

export const getDefaultPosition = () => {
  let lng = localStorage.getItem("lng")
    ? localStorage.getItem("lng")
    : "139.86448000000001";
  let lat = localStorage.getItem("lat")
    ? localStorage.getItem("lat")
    : "35.54817666666667";
  let zoom = localStorage.getItem("zoom") ? localStorage.getItem("zoom") : 13;

  return {
    lng: lng,
    lat: lat,
    zoom: zoom,
  };
};

export const calculateZoomLevel = (
  lat,
  distanceBetweenPoints,
  adjustZoomLevel = 0
) => {
  let radian = lat * (Math.PI / 180);
  let logNum = (C * Math.cos(radian)) / distanceBetweenPoints;
  let zoomLvl = Math.log2(logNum);
  return zoomLvl + adjustZoomLevel;
};
